import { useState, useEffect } from 'react';
import { fetchStakedPublisherNFTs, fetchStakedGenesisTokens } from '../services/staking';
import { genesis_RARITY, genesis_POINTS } from '../pages/Staking/constants'; 

export function useStakedPublishers(account, ready) {
    const [staked, setStaked] = useState([])
    const [fetching, setFetching] = useState(false)
    const [fetched, setFetched] = useState(false)

    useEffect(() => {
        if(ready && account) {
            setStaked([])
            setFetching(true)
            fetchStakedPublisherNFTs(account)
                .then(nfts => {
                    setStaked(nfts)
                })
                .catch(e => {
                    console.error(e)
                    setStaked([]);
                })
                .finally(() => {
                    setFetching(false)
                    setFetched(true)
                })
        }

        return () => setStaked([]);
    }, [account, ready])


    return { staked, fetching, fetched };
}

export function useStakedGenesis(account, ready) {
    const [staked, setStaked] = useState([])
    const [fetching, setFetching] = useState(false)
    const [fetched, setFetched] = useState(false)

    useEffect(() => {
        if(ready && account) {
            setStaked([])
            setFetching(true)
            fetchStakedGenesisTokens(account)
                .then(nfts => {
                    setStaked(nfts)
                })
                .catch(e => {
                    console.error(e)
                    setStaked([]);
                })
                .finally(() => {
                    setFetching(false)
                    setFetched(true)
                })
        }

        return () => setStaked([]);
    }, [account, ready])


    return { staked, fetching, fetched };
}

export function useStaked(account, ready) {
    const [stakedPublishers, setStakedPublishers] = useState([])
    const [stakedGenesis, setStakedGenesis] = useState([])
    const [stakedMapping, setStakedMapping] = useState(new Map())
    const [fetching, setFetching] = useState(false)
    const [fetched, setFetched] = useState(false)

    useEffect(() => {
        let cancel = false;

        const fetchData = async () => {
            try {
                setStakedPublishers([])
                setStakedGenesis([])
                setFetching(true)

                const [publisherNFTs, genesisNFTs] = await Promise.all([
                    fetchStakedPublisherNFTs(account),
                    fetchStakedGenesisTokens(account)
                ])

                // console.log(publisherNFTs)
                // console.log(genesisNFTs)
                
                if(!cancel) {
                    let mapping = new Map();

                    for(let i = 0; i < publisherNFTs.length; i++) {
                        let nft = publisherNFTs[i];
                        mapping.set(nft.publisher_nft_id, { 
                            publisher_nft_id: nft.publisher_nft_id,
                            golden: 0,
                            silver: 0,
                            points: 0
                        });
                    }

                    // const pnft_kv = publisherNFTs.reduce((acc, nft) => {
                    //     if(!acc[nft.publisher_nft_id]) {
                    //         acc[nft.publisher_nft_id] = { publisher_nft_id: nft.publisher_nft_id }
                    //     }

                    //     return acc;
                    // }, {})

                    for(let j = 0; j < genesisNFTs.length; j++) {
                        let nft = genesisNFTs[j];
                        if(mapping.has(nft.publisher_nft_id)) {
                            let pnft = mapping.get(nft.publisher_nft_id);
                            pnft.golden = nft.genesis_1_quantity;
                            pnft.silver = nft.genesis_2_quantity;
                            pnft.points = (nft.genesis_1_quantity * genesis_POINTS.golden 
                                + nft.genesis_2_quantity * genesis_POINTS.silver);
                        } else {
                            // only add to the mapping if the pnft is staked
                            // or there are staked genesis for the pnft
                            if(publisherNFTs.indexOf(nft.publisher_nft_id) > 0
                            || nft.genesis_1_quantity + nft.genesis_2_quantity > 0) {
                                mapping.set(nft.publisher_nft_id, { 
                                    publisher_nft_id: nft.publisher_nft_id, 
                                    golden: nft.genesis_1_quantity, 
                                    silver: nft.genesis_2_quantity, 
                                    points: (nft.genesis_1_quantity * genesis_POINTS.golden 
                                        + nft.genesis_2_quantity * genesis_POINTS.silver) });
                            }
                        }
                    }

                    // const genesis_kv = genesisNFTs.reduce((acc, nft) => {
                    //     if(!acc[nft.publisher_nft_id]) {
                    //         acc[nft.publisher_nft_id] = nft
                    //     }

                    //     return acc;
                    // }, {})

                    setStakedPublishers(publisherNFTs)
                    setStakedGenesis(genesisNFTs)

                    // for(let key in pnft_kv) {
                    //     if(genesis_kv[key]) {
                    //         pnft_kv[key].golden = genesis_kv[key].genesis_1_quantity
                    //         pnft_kv[key].silver = genesis_kv[key].genesis_2_quantity
                    //         pnft_kv[key].points = (genesis_kv[key].genesis_1_quantity * genesis_POINTS.golden 
                    //             + genesis_kv[key].genesis_2_quantity * genesis_POINTS.silver)
                    //     } else {
                    //         pnft_kv[key].golden = 0
                    //         pnft_kv[key].silver = 0
                    //         pnft_kv[key].points = 0
                    //     }
                    // }

                    // staked pnft <-> genesis mapping
                    setStakedMapping(mapping)
                }
            } catch(e) {
                console.error(e)
                setStakedPublishers([])
                setStakedGenesis([])
            } finally {
                if(!cancel) {
                    setFetching(false)
                    setFetched(true)
                }
            }
        }

        if(ready && account) {
            fetchData()
        }

        return () => {
            cancel = true;
        }
    }, [account, ready])


    return { stakedPublishers, stakedGenesis, stakedMapping, fetching, fetched };
}